export default __webpack_public_path__ + "static/media/IconDesc_AssemblyDirectorSystem.64.c9b9ab3e.png";